import AppRoute from "models/AppRoute"

const NotFoundRoute = new AppRoute({
    route: "*",
    navbar: true,
    authRequired: true,
})

export default NotFoundRoute
